import { yupResolver } from '@hookform/resolvers/yup';
import Image from 'next/image';
import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useAddUpi } from '@/api/digital-gold/bank-details/addVpa';
import closeIcon from '@/assets/images/icons/close-icon.svg';

type UpiForm = {
  vpa: string;
};

export const AddUpiModal = (props: any) => {
  const { userId } = props;
  const upiRegex: RegExp = /[a-zA-Z0-9.-_]{2,256}@[a-zA-Z]{2,64}/;
  const validateUpi = (upi: string | undefined) => {
    return yup
      .string()
      .matches(upiRegex, 'Enter valid UPI Id')
      .isValidSync(upi);
  };
  const upiSchema = yup.object({
    vpa: yup
      .string()
      .required('*Required')
      .test('vpa', 'Invalid UPI ID', (value) => {
        return validateUpi(value);
      }),
  });

  const {
    register: upiDetails,
    handleSubmit: handleSubmitUpiDetails,
    formState: { errors: upiErrors },
    reset: vpaReset,
  } = useForm<UpiForm>({
    defaultValues: {
      vpa: '',
    },
    resolver: yupResolver(upiSchema),
  });

  const upiModalCloseRef = useRef<HTMLAnchorElement>(null);
  const closeUpiModal = () => {
    upiModalCloseRef.current?.click();
  };
  const addUpiAccount = useAddUpi();
  const upiSubmit = async (upiId: UpiForm) => {
    const payLoadData = {
      vpa: upiId.vpa,
      id: userId.id,
    };
    const addUpiMessage = await addUpiAccount.mutateAsync(payLoadData);
    if (addUpiMessage?.status === 200) {
      vpaReset();
      closeUpiModal();
    }
  };
  return (
    <div
      className={`modal loanDetails__modal addressDetail__modal fade`}
      id="upiPop"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="upiPopLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal__title">
            <p className="text--semi text--black sell_p">Add UPI</p>
            <a
              // href="#"
              data-dismiss="modal"
              ref={upiModalCloseRef}
            >
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={closeIcon}
                alt="close icon"
              />
            </a>
          </div>
          <div className="interestDetail">
            <form
              autoComplete="off"
              onSubmit={handleSubmitUpiDetails(upiSubmit)}
            >
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label className="text--regular text--black" htmlFor="upi">
                      Enter UPI Id
                    </label>
                    <div className="input-form">
                      <input
                        type="text"
                        placeholder="Example@Bankname"
                        id="upi"
                        {...upiDetails('vpa')}
                      />
                    </div>
                    {upiErrors?.vpa && (
                      <p className="text--red sell_p">
                        {upiErrors?.vpa.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="action-container mt-0">
                <button
                  className="custom__button custom__button--dark border-btn backBtn text--bold"
                  data-dismiss="modal"
                  type="button"
                  id="DG_upi-close"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="custom__button custom__button--dark text--semi w-100 ml-0"
                  id="DG_upi-verify"
                >
                  Verify & Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
